import { ArrowOrientationSlab, SnowLoadIcon, useSnowLoadAssignment } from '@scene'
import { sceneConfig } from '@modugen/ui-toolkit'
import LiveLoadIcon from 'src/components/scene/LiveLoadIcon'
import ManualLoadIcon from 'src/components/scene/ManualLoadIcon'
import useLiveLoadMetadata from 'src/components/scene/hooks/useLiveLoadMetadata'
import useManualLoadAssignment from 'src/components/scene/hooks/useManualLoadAssignment'

interface Props {
  slab: ShapeObject
  outlineColor: string
  /** The plan PDF draws no load icons, so the plan view preview hides them. */
  hideLoadIcons?: boolean
}

// The slab's text label itself is drawn batched (`FloorplanModelLabels`), so
// this component only contributes the orientation arrow and the load icons.
const VerticalSlab2DLabelsAndIcons = ({ slab, outlineColor, hideLoadIcons = false }: Props) => {
  const { hasSnowLoad, pointForIcon } = useSnowLoadAssignment({ slab, offset: 2 })

  const { hasManualLoad, pointForIcon: pointForManualLoad } = useManualLoadAssignment({
    slab,
    offset: 2,
    offsetX: hasSnowLoad ? 0.6 : 0.6, // Position after snow load icon
  })

  const { liveLoadDisabled: hasLiveLoad, pointForIcon: pointForLiveLoad } = useLiveLoadMetadata({
    slab,
    offset: 2,
    offsetX: hasSnowLoad ? 0.9 : 0.3,
  })

  const numPoints = slab.shape.points.length
  if (numPoints <= 2) return <></>

  return (
    <group layers={sceneConfig.R3FNonSelectableObjectLayer}>
      <ArrowOrientationSlab slab={slab} color={outlineColor} />
      {hasSnowLoad && !hideLoadIcons && (
        <SnowLoadIcon hasSnowLoad={hasSnowLoad} pointForIcon={pointForIcon} color={outlineColor} />
      )}
      {hasLiveLoad && !hideLoadIcons && slab.element_type === 'vertical_slabs' && (
        <LiveLoadIcon
          hasLiveLoad={hasLiveLoad}
          pointForIcon={pointForLiveLoad}
          color={outlineColor}
        />
      )}
      {hasManualLoad && !hideLoadIcons && (
        <ManualLoadIcon
          hasManualLoad={hasManualLoad}
          pointForIcon={pointForManualLoad}
          color={outlineColor}
        />
      )}
    </group>
  )
}

export default VerticalSlab2DLabelsAndIcons
